import React from 'react';
import { Button } from 'primereact/button';

export default function FloatingWhatsAppButton() {
    const phoneNumber = '51978326796'; // Número seleccionado
    const tikTokUrl = 'https://www.tiktok.com/@laptops_pebydigitalwins';

    const openWhatsApp = () => {
        window.open(`https://wa.me/${phoneNumber}`, '_blank', 'noopener,noreferrer');
    };
    const openTikTok = () => {
        window.open(tikTokUrl, '_blank', 'noopener,noreferrer');
    };

    return (
        <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 1000 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <Button icon="pi pi-tiktok" className="p-button-rounded p-button-lg" style={{ backgroundColor: '#000000', borderColor: '#000000', color: '#ffffff', boxShadow: '0 4px 16px rgba(0, 0, 0, 0.35)' }} onClick={openTikTok} aria-label="TikTok" tooltip="Visítanos en TikTok" tooltipOptions={{ position: 'top' }} />
                <Button icon="pi pi-whatsapp" className="p-button-rounded p-button-lg" style={{ backgroundColor: '#25D366', borderColor: '#25D366', color: '#ffffff', boxShadow: '0 4px 16px rgba(37, 211, 102, 0.4)' }} onClick={openWhatsApp} aria-label="WhatsApp" tooltip="Chatea por WhatsApp" tooltipOptions={{ position: 'top' }} />
            </div>
        </div>
    );
}
